"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createConfigurationUrl = createConfigurationUrl;
var _types = require("../types");
var _isAzureRegion = require("./isAzureRegion");
function createConfigurationUrl(configurationType, environment,
// eslint-disable-next-line @typescript-eslint/no-redundant-type-constituents -- Intended siplification
regionOrTenant) {
  const urlParts = [];
  if (configurationType === _types.ConfigurationType.Authentication) {
    urlParts.push('authentications');
  }
  if (configurationType === _types.ConfigurationType.Common) {
    urlParts.push('common');
  }
  if (configurationType === _types.ConfigurationType.Hierarchy) {
    urlParts.push('hierarchy');
  }
  if (configurationType === _types.ConfigurationType.Messaging) {
    urlParts.push('messaging');
  }
  if (configurationType === _types.ConfigurationType.Url) {
    urlParts.push('urls');
  }
  if (environment) {
    urlParts.push('environments', environment);
  }
  if (regionOrTenant === 'azure-regions') {
    urlParts.push('azureregions');
  } else if (regionOrTenant === 'tenants') {
    urlParts.push('tenants');
  } else if ((0, _isAzureRegion.isAzureRegion)(regionOrTenant)) {
    urlParts.push('azureregions', regionOrTenant);
  } else if (regionOrTenant) {
    urlParts.push('tenants', regionOrTenant);
  }
  urlParts.push('config.json');
  return urlParts.filter(Boolean).join('/').toLowerCase();
}
//# sourceMappingURL=createConfigurationUrl.js.map